import WorkersTable from './WorkersTable';

export default WorkersTable;
